(function () {
  'use strict';

  function init(root) {
    var subscribeBtn = root.querySelector('#subscribe-btn');
    var policyCheckbox = root.querySelector('#policy-checkbox');
    var form = root.querySelector('#email-signup-form');
    var emailInput = root.querySelector('#email-input');
    var messageDiv = root.querySelector('#email-signup-message');
    var policyTooltip = root.querySelector('#policy-tooltip');

    if (!form) return;

    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function hideTooltip() {
      policyTooltip.style.display = 'none';
    }

    function showTooltip() {
      policyTooltip.style.display = 'inline-block';
    }

    form.addEventListener('submit', function (e) {
      var email = emailInput.value.trim();
      if (!policyCheckbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showTooltip();
        return false;
      } else {
        hideTooltip();
      }
      if (!validateEmail(email)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        messageDiv.textContent = 'Please enter a valid email address.';
        messageDiv.style.color = '#e74c3c';
        return false;
      } else {
        messageDiv.textContent = '';
      }
    });

    policyCheckbox.addEventListener('change', function () {
      if (policyCheckbox.checked) hideTooltip();
    });

    if (subscribeBtn) {
      subscribeBtn.addEventListener('click', function () {
        hideTooltip();
      });
    }

    if (window.location.search.includes('esfb_subscribed=1')) {
      messageDiv.textContent = 'Subscription successful! Thank you for subscribing.';
      messageDiv.style.color = '#00ff6c';
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('esfb_subscribed');
      window.history.replaceState({}, document.title, cleanUrl.toString());
    }
  }

  var banner = document.querySelector('.email-signup-banner-custom');
  if (banner) init(banner);
})();
